import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form } from "react-bootstrap";
import ExcelDownload from "../../../components/ExcelDownload";
import DateFilter from "../../../components/filter/DateFilter";
import PaginateCard from "../../../components/PaginateCard";
import CompanyEnum from "../../../enums/company/CompanyEnum";
import useCity from "../../../hooks/useCity";
import useFilterParams from "../../../hooks/useFilterParams";
import useProvince from "../../../hooks/useProvince";
import { getAuthMethod } from "../../../modules/helper";
import MainMenu from "../../../modules/public/mainMenu/mainMenu";
import ModalDetails from "./ModalDetails";
import TableShipments from "./TableShipments";

const ListShipmentsPage = () => {
  const { getParam, getAllParams, setParam } = useFilterParams({
    page: 1,
    items: 10,
  });
  const { provinces } = useProvince({ initiate: true });
  const { getCitiesByProviceId } = useCity();

  const [cities, setCities] = useState([]);
  const [modalDetails, setModalDetails] = useState(null);

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["agentListShipments"],
    queryFn: () =>
      getAuthMethod("/totalpost/v1/agent/listOfShipments", getAllParams()).then(
        res => {
          if (res.status === 200) {
            return res.data.data;
          }

          return {
            count: 0,
            items: [],
          };
        }
      ),

    initialData: {
      count: 0,
      items: [],
    },
    retry: 0,
    retryOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    const getCity = async () => {
      if (getParam("getterProvince")) {
        const cities = await getCitiesByProviceId(getParam("getterProvince"));
        setCities(cities);
      }
    };
    getCity();
  }, []);

  const children = (
    <Container className="pt-3">
      <h3>لیست مرسولات</h3>
      <form
        onSubmit={e => {
          e.preventDefault();
          setParam("page", 1);
          refetch();
        }}
      >
        <Card className="mt-4 flex-wrap flex-row row-gap-3">
          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>تعداد نمایش:</Form.Label>
            <Form.Select
              value={getParam("items")}
              onChange={e => setParam("items", e.target.value)}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </Form.Select>
          </Col>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>سرویس دهنده:</Form.Label>
            <Form.Select
              value={getParam("companyId")}
              onChange={e => setParam("companyId", e.target.value)}
            >
              <option value="0">همه</option>
              {Object.keys(CompanyEnum).map(item => (
                <option key={item} value={item}>
                  {CompanyEnum[item]}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>وضعیت:</Form.Label>
            <Form.Select
              value={getParam("status")}
              onChange={e => setParam("status", e.target.value)}
            >
              <option value="">همه</option>
              <option value="تایید نهایی">تایید نهایی</option>
              <option value="جمع آوری نشده">جمع آوری نشده</option>
              <option value="ارجاع به راننده">ارجاع به راننده</option>
              <option value="معلق">معلق در فروشگاه</option>
              <option value="تحویل داده شده">تحویل سرویس دهنده</option>
              <option value="برگشتی">برگشتی</option>
              <option value="تحویل مشتری">تحویل مشتری</option>
              <option value="لغو موقت">لغو موقت</option>
              <option value="لغو شده">لغو شده</option>
            </Form.Select>
          </Col>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>نوع پرداخت:</Form.Label>
            <Form.Select
              value={getParam("methodPayment")}
              onChange={e => setParam("methodPayment", e.target.value)}
            >
              <option value="0">همه</option>
              <option value="1">پیشکرایه</option>
              <option value="2">پسکرایه</option>
              <option value="3">COD</option>
            </Form.Select>
          </Col>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>شماره سفارش:</Form.Label>
            <Form.Control
              type="number"
              value={getParam("numberParcel")}
              onChange={e => setParam("numberParcel", e.target.value)}
            />
          </Col>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>بارکد:</Form.Label>
            <Form.Control
              type="text"
              value={getParam("barcode")}
              onChange={e => setParam("barcode", e.target.value)}
            />
          </Col>

          <div className="w-100 px-2">
            <Col
              xs={12}
              sm={6}
              lg={4}
              xxl={3}
              className="d-flex align-items-center px-2 column-gap-2 border rounded"
              style={{ height: 38 }}
            >
              <Form.Check
                id="r2Acf56aaRa55"
                checked={getParam("createdByMySelf")}
                onChange={e =>
                  setParam("createdByMySelf", e.target.checked ? 1 : 0)
                }
              />
              <Form.Label
                htmlFor="r2Acf56aaRa55"
                className="c-pointer user-select-none mb-0"
              >
                فقط مرسولاتی که خودم ثبت کردم
              </Form.Label>
            </Col>
          </div>

          <div className="w-100 px-2">
            <h5 className="mt-2 mb-0">فرستنده</h5>
          </div>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>نام و نام خانوادگی:</Form.Label>
            <Form.Control
              value={getParam("senderName")}
              onChange={e => setParam("senderName", e.target.value)}
            />
          </Col>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>شماره همراه:</Form.Label>
            <Form.Control
              type="number"
              value={getParam("senderPhone")}
              onChange={e => setParam("senderPhone", e.target.value)}
            />
          </Col>

          <div className="w-100 px-2">
            <h5 className="mt-4 mb-0">گیرنده</h5>
          </div>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>نام و نام خانوادگی:</Form.Label>
            <Form.Control
              value={getParam("getterName")}
              onChange={e => setParam("getterName", e.target.value)}
            />
          </Col>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>شماره همراه:</Form.Label>
            <Form.Control
              type="number"
              value={getParam("getterPhone")}
              onChange={e => setParam("getterPhone", e.target.value)}
            />
          </Col>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>استان:</Form.Label>
            <Form.Select
              value={getParam("getterProvince")}
              onChange={async e => {
                const id = e.target.value !== "0" ? e.target.value : null;
                setParam("getterProvince", id);
                setParam("getterCity", undefined);

                if (id !== null) {
                  const cities = await getCitiesByProviceId(id);
                  setCities(cities);
                } else {
                  setCities([]);
                }
              }}
            >
              <option value="0">همه</option>
              {provinces.map(item => (
                <option key={item.id} value={item.id}>
                  {item.faName}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <Form.Label>شهر:</Form.Label>
            <Form.Select
              value={getParam("getterCity") ?? "0"}
              onChange={e => setParam("getterCity", e.target.value)}
            >
              <option value="0">همه</option>
              {cities.map(item => (
                <option key={item.id} value={item.id}>
                  {item.faName}
                </option>
              ))}
            </Form.Select>
          </Col>

          <div className="w-100" />
          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <DateFilter
              value={getParam("startDate")}
              label="از تاریخ:"
              set={value => setParam("startDate", value)}
            />
          </Col>
          <Col xs={12} sm={6} lg={4} xxl={2} className="px-2">
            <DateFilter
              value={getParam("endDate")}
              label="تا تاریخ:"
              set={value => setParam("endDate", value)}
            />
          </Col>

          <div className="w-100 mt-3 px-2">
            <Button type="submit">فیلتر</Button>
          </div>
        </Card>
      </form>

      <TableShipments
        data={data}
        isFetching={isFetching}
        setModalDetails={setModalDetails}
      />

      <ExcelDownload
        params={{ isExcel: 1, ...getAllParams() }}
        className="btn-success mt-1"
        url="/totalpost/v1/agent/listOfShipments"
      />

      <div className="my-5">
        <PaginateCard
          count={data.count}
          numberItems={getParam("items")}
          numberPage={getParam("page")}
          onIndexChoose={number => {
            setParam("page", number);
            refetch();
          }}
        />
      </div>

      <ModalDetails
        show={!!modalDetails}
        onClose={() => setModalDetails(null)}
        shipment={modalDetails}
      />
    </Container>
  );

  return <MainMenu data={children} />;
};

export default ListShipmentsPage;
